import { Link, useLocation } from "react-router-dom";
import { images } from "../assets/img";
import { useState } from "react";
import { Language } from "./Languages";
import { t } from "../utils/utils";
import { headerItems } from "../data/home";
import { useAppStore } from "../store/useAppStore";

// "/" only matches the home page; other items also match their sub-pages
// (e.g. "/blog" is active on "/blog/12"). Query strings are ignored.
function isActivePath(pathname, url) {
  const path = url.split("?")[0];

  if (path === "/") return pathname === "/";

  return pathname === path || pathname.startsWith(`${path}/`);
}

export function Header() {
  const { pathname } = useLocation();
  const { appLang } = useAppStore();
  const [hovering, setHovering] = useState(false);
  const [isOpen, setIsOpne] = useState(false);

  function handleClick() {
    hideMenu();
  }

  function handleChildClick() {
    setHovering(false);
    hideMenu();
  }

  function hideMenu() {
    setIsOpne(false);
  }

  function toggleMenu() {
    setIsOpne((prev) => !prev);
  }

  return (
    <div id="navMenu">
      <div className="navCont cont1">
        <div id="navLogo">
          <Link to="/">
            <img src={images.logo} alt="ProTax Advisors" />
          </Link>
        </div>
        <div className="menuCont">
          <div className="burgerIcon" onClick={toggleMenu}>
            <div></div>
            <div></div>
            <div></div>
          </div>{" "}
          <div className={`menuList ${isOpen ? "open" : ""}`}>
            {headerItems[appLang].map((el, i) => (
              <div
                className={`item ${isActivePath(pathname, el.url) ? "active" : ""}`}
                onMouseEnter={() => el.items && setHovering(true)}
                onMouseLeave={() => el.items && setHovering(false)}
                key={i}
              >
                <Link
                  to={el.url}
                  onClick={handleClick}
                  // style={{ pointerEvents: el.items ? "none" : "auto" }}
                >
                  {el.label}
                </Link>
                {el.items && hovering && (
                  <>
                    <div
                      className="dropdown"
                      style={{ display: "flex" }}
                      // style={{ display: hovering ? "flex" : "none" }}
                    >
                      {el.items?.map((el, i) => (
                        <Link to={el.url} onClick={handleChildClick} key={i}>
                          {el.label}
                        </Link>
                      ))}
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>

        <Link className="navContactUs" to="/?scroll=homeContacts">
          {t.contactUs}
        </Link>
        <Language />
      </div>
    </div>
  );
}
